import { book_sports_facility_white, e_shop_white } from '../../assets/base64';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { NavigationService } from '../../services/navigation';
import { MenuItem } from './types';
import { logout } from '../../services/redux/reducers/AuthSlice';
import { store } from '../../services/redux';
import { Alert } from '../../services/alert';

export const menuItems: MenuItem[] = [
  {
    title: 'Member Home',
    contents: [],
    icon: require('../../assets/home-white.png'),
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'HomeTab',
      });
    },
  },
  {
    title: 'Sports',
    contents: [
      {
        title: 'Facility Booking',
        onPress: () => {
          NavigationService.push<'Sports'>('Sports', {
            screen: 'Facility',
          });
        },
      },
      {
        title: 'Sports Coaching',
        onPress: () => {
          NavigationService.push<'Sports'>('Sports', {
            screen: 'Coaching',
          });
        },
      },
    ],
    icon: IS_WEB
      ? addBase64Prefix(book_sports_facility_white)
      : require('../../assets/book-sports-facility.png'),
    isCollapse: true,
    onPress: () => {
      NavigationService.push<'Sports'>('Sports', {
        screen: 'Facility',
      });
    },
  },
  {
    title: 'Events',
    contents: [
      {
        title: 'Upcoming Events',
        onPress: () => {
          NavigationService.push<'EventList'>('EventList', {
            screen: 'Grid',
          });
        },
      },
      // {
      //   title: 'Event Calendar',
      //   onPress: () => {
      //     NavigationService.push<'EventList'>('EventList', {
      //       screen: 'Calendar',
      //     });
      //   },
      // },
    ],
    icon: require('../../assets/events.png'),
    isCollapse: true,
    onPress: () => {
      NavigationService.push<'EventList'>('EventList', {
        screen: 'Grid',
      });
    },
  },
  {
    title: 'Dining',
    contents: [
      {
        title: 'Dining Reservation',
        onPress: () => {
          NavigationService.push('GrillRoom');
        },
      },
      {
        title: 'Book Private Function',
        onPress: () => {
          NavigationService.push('PrivateFunction');
        },
      },
      {
        title: 'Dining Promotion',
        onPress: () => {
          NavigationService.push('DinningPromotion');
        },
      },
      {
        title: 'Dining Menus',
        onPress: () => {
          NavigationService.push('DinningMenu');
        },
      },
    ],
    icon: require('../../assets/dining_icon.png'),
    isCollapse: true,
    onPress: () => {
      NavigationService.push('GrillRoom');
    },
  },
  {
    title: 'E-Shop',
    contents: [
      {
        title: 'Food',
        onPress: () => {
          NavigationService.push('EShopCategoryPage', {
            name: 'food',
          });
        },
      },
      {
        title: 'Beverages',
        onPress: () => {
          NavigationService.push('EShopCategoryPage', {
            name: 'beverages',
          });
        },
      },
      {
        title: 'Sport Accessories',
        onPress: () => {
          NavigationService.push('EShopCategoryPage', {
            name: 'sporting-accessories',
          });
        },
      },
      {
        title: 'Clothing',
        onPress: () => {
          NavigationService.push('EShopCategoryPage', {
            name: 'clothing',
          });
        },
      },
      {
        title: 'Health',
        onPress: () => {
          NavigationService.push('EShopCategoryPage', {
            name: 'health',
          });
        },
      },
      {
        title: 'Merchandise',
        onPress: () => {
          NavigationService.push('EShopCategoryPage', {
            name: 'merchandise',
          });
        },
      },
    ],
    icon: IS_WEB
      ? addBase64Prefix(e_shop_white)
      : require('../../assets/e-shop-white.png'),
    isCollapse: true,
    onPress: () => {
      NavigationService.push('EShopHomePage');
    },
  },
  {
    title: 'Club Services',
    contents: [
      {
        title: 'Services & Forms',
        onPress: () => {
          NavigationService.push('ServiceForm');
        },
      },
      {
        title: 'Survey',
        onPress: () => {
          NavigationService.push('Survey');
        },
      },
      {
        title: 'Feedback',
        onPress: () => {
          NavigationService.push('Feedback');
        },
      },
      {
        title: 'Recriprocal Clubs',
        onPress: () => {
          NavigationService.push('ReciprocalClubs');
        },
      },
    ],
    icon: require('../../assets/services-forms.png'),
    onPress: () => {
      NavigationService.push('ServiceForm');
    },
    isCollapse: true,
  },
  {
    title: 'News',
    contents: [
      {
        title: 'News',
        onPress: () => {},
      },
      {
        title: 'Notices',
        onPress: () => {},
      },
    ],
    icon: require('../../assets/news.png'),
    isCollapse: false,
    onPress: () => {
      NavigationService.push<'ClubNews'>('ClubNews');
    },
  },
  {
    title: 'Notices',
    contents: [],
    icon: require('../../assets/notices.png'),
    isCollapse: false,
    onPress: () => {
      NavigationService.push<'Notices'>('Notices', {
        screen: 'new',
      });
    },
  },
  {
    title: 'My Account',
    contents: [
      {
        title: 'My Profile',
        onPress: () => {
          NavigationService.push('Root', {
            screen: 'MyAccountTab',
          });
        },
      },
      {
        title: 'My Account Statement',
        onPress: () => {
          NavigationService.push('AccountStatememt');
        },
      },
      {
        title: 'My Bookings',
        onPress: () => {
          NavigationService.push('Root', {
            screen: 'MyBookingsTab',
          });
        },
      },
      {
        title: 'My Orders',
        onPress: () => {
          NavigationService.push('Root', {
            screen: 'MyOrdersTab',
          });
        },
      },
      {
        title: 'My Preferences',
        onPress: () => {
          NavigationService.push('MyPreferences');
        },
      },
      {
        title: 'Contact Us',
        onPress: () => {
          NavigationService.navigate('ContactUs');
        },
      },
    ],
    icon: require('../../assets/my-account.png'),
    isCollapse: true,
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'MyAccountTab',
      });
    },
  },
  {
    title: 'Logout',
    contents: [],
    onPress: () => {
      Alert.alert('Logout', 'You want to logout?', [
        {
          text: 'Ok',
          onPress: () => {
            store.dispatch(logout());
            NavigationService.push('Login');
          },
        },
        {
          text: 'Cancel',
          onPress: () => {},
        },
      ]);
    },
    icon: require('../../assets/logout_icon.png'),
  },
];
